import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import api from '../api/axios';
import { Plus, X } from 'lucide-react';

const EMPTY = { machine_id:'', name:'', machine_type:'DRILLING', fuel_type:'DIESEL', gprs_enabled:false, notes:'' };

export default function MachinesPage() {
  const [machines, setMachines]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm]           = useState(EMPTY);
  const [saving, setSaving]       = useState(false);
  const [error, setError]         = useState('');
  const [msg, setMsg]             = useState('');

  const load = () => {
    setLoading(true);
    api.get('/machines/').then(r => setMachines(r.data.results || [])).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async e => {
    e.preventDefault(); setSaving(true); setError('');
    try {
      await api.post('/machines/', form);
      setShowModal(false); setForm(EMPTY); load();
      setMsg('Machine added!'); setTimeout(() => setMsg(''), 3000);
    } catch (err) {
      const errs = err.response?.data?.errors;
      setError(errs ? Object.values(errs).flat().join(', ') : 'Failed to save.');
    } finally { setSaving(false); }
  };

  return (
    <Layout
      title="Machines"
      subtitle="Machine master and GPRS tracking"
      actions={<button className="btn btn-primary" onClick={() => setShowModal(true)}><Plus size={14}/>Add Machine</button>}
    >
      {msg && <div className="success-box">{msg}</div>}

      <div className="card">
        {loading ? (
          <div className="loading"><div className="spinner"/>Loading...</div>
        ) : machines.length === 0 ? (
          <div className="empty-state"><p>No machines registered.</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Machine ID</th><th>Name</th><th>Type</th><th>Fuel</th><th>GPRS</th><th>Status</th></tr>
              </thead>
              <tbody>
                {machines.map(m => (
                  <tr key={m.id}>
                    <td style={{ color:'var(--brand)', fontWeight:600 }}>{m.machine_id}</td>
                    <td style={{ fontWeight:600, color:'var(--text-primary)' }}>{m.name}</td>
                    <td><span className="badge badge-blue">{m.machine_type?.replace('_',' ')}</span></td>
                    <td>{m.fuel_type}</td>
                    <td>{m.gprs_enabled ? <span className="badge badge-green">Enabled</span> : <span className="badge badge-muted">Disabled</span>}</td>
                    <td>{m.is_active ? <span className="badge badge-green">Active</span> : <span className="badge badge-red">Inactive</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div><h3>Add Machine</h3></div>
              <button onClick={() => setShowModal(false)} style={{ background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer', fontSize:18 }}>×</button>
            </div>
            <form onSubmit={handleCreate}>
              <div className="modal-body">
                {error && <div className="error-box">{error}</div>}
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Machine ID *</label>
                    <input className="form-input" required value={form.machine_id} onChange={e => setForm({...form, machine_id:e.target.value})} placeholder="e.g. DRL-001"/>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Name *</label>
                    <input className="form-input" required value={form.name} onChange={e => setForm({...form, name:e.target.value})}/>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Type</label>
                    <select className="form-input" value={form.machine_type} onChange={e => setForm({...form, machine_type:e.target.value})}>
                      {['DRILLING','WIRE_SAW','GANGSAW','COMPRESSOR','GENERATOR','CRANE','POCLAIN','TIPPER','OTHER'].map(t => (
                        <option key={t} value={t}>{t.replace('_',' ')}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Fuel Type</label>
                    <select className="form-input" value={form.fuel_type} onChange={e => setForm({...form, fuel_type:e.target.value})}>
                      <option value="DIESEL">Diesel</option>
                      <option value="PETROL">Petrol</option>
                      <option value="ELECTRIC">Electric</option>
                      <option value="NONE">None</option>
                    </select>
                  </div>
                  <div className="form-group" style={{ gridColumn:'1/-1' }}>
                    <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, fontWeight:500, color:'var(--text-secondary)' }}>
                      <input type="checkbox" checked={form.gprs_enabled} onChange={e => setForm({...form, gprs_enabled:e.target.checked})} style={{ width:15, height:15 }}/>
                      GPRS Enabled (DQ500)
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving...' : 'Add Machine'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
